module.exports = __webpack_public_path__ + "static/media/zionquentin.ff52be60.jpg";